module.exports = __webpack_public_path__ + "static/media/cresyn1@2x.2bdc5dec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/monoshift/cresyn1@2x.jpg
// module id = 153
// module chunks = 0